import { gql } from 'apollo-angular';

export const GetTechnicalStatus = gql`
  query getTechnicalBreakStatus {
    getTechnicalBreakStatus
  }
`;
